import { TRACK_VALIDATION_ERROR } from '../actions/TrackingActions';
import { logError } from '@zg-rentals/log-error';
import { VALIDATION_ERROR } from '../../utils/customErrorTypes';

export const tracking =
  ({ getState }) =>
  (next) =>
  (action) => {
    const storeState = getState();

    const userPayload = {
      user: {
        email: storeState.user.email,
        role: storeState.user.roles,
        userToken: storeState.user.userToken,
        userId: storeState.user.userToken,
      },
    };

    // Will track error from redux-api-middleware and their api response.
    // action.error will be generated by redux-api-middleware and action.payload.error
    // is the error response from backend.
    if (action.error) {
      /* the shape of action in this case is (from docs & logs):
        {
          type: string; // ex: "PAYMENTS/LANDLORD/REQUEST_LANDLORD_STATUS_FAIL"
          payload: Error; // An ApiError object
          error: boolean;
        };
      */
      logError({
        error: action.payload.error,
        errorType: 'HTTPError',
        context: {
          actionType: action.type,
          ...userPayload,
        },
      });
    }

    // Tracking for validation error
    if (action.type === TRACK_VALIDATION_ERROR) {
      logError({
        error: new Error('Validation error'),
        errorType: VALIDATION_ERROR,
        context: {
          ...action.payload.data,
          ...userPayload,
        },
      });
    }

    return next(action);
  };
